
const KEY = "adm_client_ip";
const FRESH_MS = 30 * 60 * 1000;
const RETRY_MS = 2 * 60 * 1000;
const TIMEOUT_MS = 4000;
const LOOKS_LIKE_IP = /^[0-9a-fA-F:.]{3,45}$/;

let inflight = null;

function readCache() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

function writeCache(ip) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ip: ip || "", ts: Date.now() }));
  } catch {
    // a blocked storage just means asking again next time
  }
}

const SOURCES = [
  async (signal) => (await (await fetch("https://api.ipify.org?format=json", { signal })).json())?.ip,
  async (signal) => /^ip=(.+)$/m.exec(await (await fetch("https://www.cloudflare.com/cdn-cgi/trace", { signal })).text())?.[1],
];

// Both are asked at once, but ipify (IPv4 only) is the one that counts when it answers,
// so a device with IPv6 does not flip between its two addresses depending on speed.
function fetchFromAny(signal) {
  const ask = (source) =>
    source(signal).then(
      (ip) => {
        const clean = String(ip || "").trim();
        return LOOKS_LIKE_IP.test(clean) ? clean : undefined;
      },
      () => undefined
    );
  const [primary, ...backups] = SOURCES.map(ask);
  return primary.then((ip) => ip || Promise.all(backups).then((all) => all.find(Boolean)));
}

async function fetchIp() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  let ip;
  try {
    ip = await fetchFromAny(controller.signal);
  } finally {
    clearTimeout(timer);
    controller.abort();
  }
  // A failure is remembered too, so a blocked service is not retried on every click.
  writeCache(ip);
  return ip;
}

export function getClientIp() {
  const cached = readCache();
  if (cached && Date.now() - cached.ts < (cached.ip ? FRESH_MS : RETRY_MS)) {
    return Promise.resolve(cached.ip || undefined);
  }
  if (!inflight) {
    inflight = fetchIp().finally(() => {
      inflight = null;
    });
  }
  return inflight;
}
